import { CommonActionType } from './action.type';

export const CommonActions = {
    async [CommonActionType.SetExchangeRate]({commit}, rate) {
        commit(CommonActionType.SetExchangeRate, rate);
    },

    async [CommonActionType.SetMinFeeBuy]({commit}, minFeeBuy) {
        commit(CommonActionType.SetMinFeeBuy, minFeeBuy);
    },

    async [CommonActionType.FeeBuyPro]({commit}, feeBuyPro) {
        commit(CommonActionType.FeeBuyPro, feeBuyPro);
    },

    async [CommonActionType.SetCustomerLevels]({commit}, customerLevels) {
        commit(CommonActionType.SetCustomerLevels, customerLevels);
    },

    async [CommonActionType.SetWarehouse]({commit}, warehouse) {
        commit(CommonActionType.SetWarehouse, warehouse);
    },

    async [CommonActionType.SetChinaStore]({commit}, chinaStore) {
        commit(CommonActionType.SetChinaStore, chinaStore);
    },

    async [CommonActionType.SetFeeGuarantee]({commit}, feeGuarantee) {
        commit(CommonActionType.SetFeeGuarantee, feeGuarantee);
    },

    async [CommonActionType.SetSafeLevel]({commit}, safeLevel) {
        commit(CommonActionType.SetSafeLevel, safeLevel);
    },

    async [CommonActionType.ShowHideMenuLeft]({commit}, isShowMenuLeft) {
        commit(CommonActionType.ShowHideMenuLeft, isShowMenuLeft);
    },

    async [CommonActionType.SetConfiguration]({commit}, configuration) {
        commit(CommonActionType.SetConfiguration, configuration);
    },

    async [CommonActionType.SetAvailableVoucher]({commit}, data) {
        commit(CommonActionType.SetAvailableVoucher, data);
    },
};

